import { Action, createReducer, on } from '@ngrx/store';
import { IAddCardResponse, IAddDebitResponse } from '../models/addCreditCard.model';
import * as fromActions from '../actions';

export const addCreditCardFeatureKey = 'addCreditCard';

export interface State {
  addCreditCardRequest: any;
  addCreditCardResponse: IAddCardResponse;
  addDebitCardRequest: any;
  addDebitCardResponse: IAddDebitResponse;
  addCreditCardFailure: Error | any;
  loaded: boolean;
}

export const initialState: State = {
  loaded: false,
  addCreditCardRequest: undefined,
  addCreditCardResponse: undefined,
  addCreditCardFailure: undefined,
  addDebitCardRequest: undefined,
  addDebitCardResponse: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromActions.loadAddCreditCards, (state, action) => ({
    ...state,
    addCreditCardRequest: action.request
  })),
  on(fromActions.loadAddCreditCardsSuccess, (state, action) => ({
    ...state,
    addCreditCardResponse: action.response,
    loaded: true
  })),
  on(fromActions.loadAddDebitCards, (state, action) => ({
    ...state,
    addDebitCardRequest: action.request
  })),
  on(fromActions.loadAddDebitSuccess, (state, action) => ({
    ...state,
    addDebitCardResponse: action.response,
    loaded: true
  })),
  on(fromActions.loadAddCreditCardsFailure, (state, action) => ({
    ...state,
    addCreditCardFailure: action.error
  }))
);

export const addCreditCardResponse = (state: State) => state.addCreditCardResponse;
export const loadCreditCardFailure = (state: State) => state.addCreditCardFailure;

export const addDebitCardResponse = (state: State) => state.addDebitCardResponse;
